












import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Rating extends Vue {
    @Prop({})
    level!: number;

    rate: number = 6;
}

